import React, { useEffect } from 'react'

interface ProductVideoProps {
  videoSrc: string
  videoRef: React.RefObject<HTMLVideoElement | null>
  onPlayingChange: (isPlaying: boolean) => void
}

const ProductVideo: React.FC<ProductVideoProps> = ({
  videoSrc,
  videoRef,
  onPlayingChange,
}) => {
  useEffect(() => {
    const videoElement = videoRef?.current
    if (!videoElement) return
    const handlePlay = () => onPlayingChange(true)
    const handlePause = () => onPlayingChange(false)
    videoElement.addEventListener('play', handlePlay)
    videoElement.addEventListener('pause', handlePause)
    return () => {
      videoElement.removeEventListener('play', handlePlay)
      videoElement.removeEventListener('pause', handlePause)
    }
  }, [videoRef, onPlayingChange])
  return (
    <div className='relative h-full w-full'>
      <video
        ref={videoRef}
        src={videoSrc}
        className='product-video-main h-full w-full object-cover'
        autoPlay
        loop
        muted
        playsInline
        controls={false}
      />
    </div>
  )
}

export default ProductVideo
